import EditAreaTypeContainer from "./EditAreaTypeContainer";
export default EditAreaTypeContainer;
